import { type SalesPartnerMountRequest } from "../salesPartnerTypes";
import { resolveApiUrl } from "../../utils/url/urlResolver";

export function getCompanyList(keyword: string): Promise<SalesPartnerMountRequest> {
    const url = createUrlFromInputValues(keyword);

    return fetch(url, {
        method: "GET",
        credentials: "same-origin", // include, omit
        mode: "cors", // no-cors, same-origin
        referrer: "no-referrer", // client
        headers: {
            dataType: "json",
            "content-type": "application/json",
        },
    }).then((response) => {
        if (!response.ok) {
            throw alert("Error status: " + response.status + ", please try again");
        } else {
            return response.json();
        }
    });
}

export function createUrlFromInputValues(keyword: string): string {
    const params = new URLSearchParams();
    params.set("keyword", keyword);

    return resolveApiUrl(`/store-finder/basic-data?${params}`);
}
